import React, { useEffect } from 'react';
import ModalPortal from './ModalPortal';
import './AlertModal.css';

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  type?: 'error' | 'success' | 'warning' | 'info';
}

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, title, message, type = 'error' }) => {
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const getIcon = (): string => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '❌';
    }
  };

  const getTypeClass = (): string => {
    switch (type) {
      case 'success':
        return 'alert-success';
      case 'warning':
        return 'alert-warning';
      case 'info':
        return 'alert-info';
      default:
        return 'alert-error';
    }
  };

  const getDefaultTitle = (): string => {
    switch (type) {
      case 'success':
        return 'Sucesso';
      case 'warning':
        return 'Atenção';
      case 'info':
        return 'Informação';
      default:
        return 'Erro';
    }
  };

  return (
    <ModalPortal>
      <div className="alert-modal-overlay" onClick={onClose}>
      <div className={`alert-modal ${getTypeClass()}`} onClick={(e) => e.stopPropagation()}>
        <div className="alert-modal-header">
          <div className="alert-modal-icon">{getIcon()}</div>
          <h3>{title || getDefaultTitle()}</h3>
          <button className="alert-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="alert-modal-body">
          <p>{message}</p>
        </div>
        <div className="alert-modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default AlertModal;
